// TOC — builds a Contents list for a single post by scanning
// h2s inside .gg-prose, then keeps the active anchor highlighted
// as the reader scrolls.
//
// A target with data-post-toc-depth="3" also lists the h3s, indented
// under their h2 (the /guide/ page uses this; essays stay h2-only).
//
// Only activates when:
//   - a [data-post-toc] target exists (post template)
//   - at least one h2 inside .gg-prose has an id
//   - the post isn't a Testimonial (post_class adds tag-testimonial):
//     an athlete's story reads as a story, not a manual
//
// Ghost's Koenig editor auto-generates slug IDs on heading blocks,
// so this works for any post authored with h2s.

export default function toc() {
    const target = document.querySelector("[data-post-toc]");
    const wrap = document.querySelector("[data-post-toc-wrap]");
    if (!target || !wrap) return;
    if (document.querySelector(".gg-post.tag-testimonial")) return;

    const deep = target.dataset.postTocDepth === "3";
    const headings = document.querySelectorAll(
        deep ? ".gg-prose h2[id], .gg-prose h3[id]" : ".gg-prose h2[id]"
    );
    if (!headings.length) return;

    // Build anchors
    const anchors = [];
    headings.forEach((h) => {
        const a = document.createElement("a");
        a.href = "#" + h.id;
        a.textContent = h.textContent;
        if (h.tagName === "H3") a.className = "is-sub";
        target.appendChild(a);
        anchors.push(a);
    });

    wrap.removeAttribute("hidden");

    // Active-section highlight on scroll
    if (!("IntersectionObserver" in window)) return;

    // When the list is taller than the rail, scroll the rail (not the
    // page) so the active link stays visible
    const rail = wrap.closest(".gg-post__side");
    const keepInView = (a) => {
        if (!rail || rail.scrollHeight <= rail.clientHeight) return;
        const box = rail.getBoundingClientRect();
        const link = a.getBoundingClientRect();
        if (link.top < box.top || link.bottom > box.bottom) {
            rail.scrollTop += link.top - box.top - rail.clientHeight / 3;
        }
    };

    const io = new IntersectionObserver(
        (entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    const id = e.target.id;
                    anchors.forEach((a) => {
                        const on = a.getAttribute("href") === "#" + id;
                        a.classList.toggle("is-active", on);
                        if (on) keepInView(a);
                    });
                }
            });
        },
        { rootMargin: "-30% 0px -60% 0px" }
    );

    headings.forEach((h) => io.observe(h));
}
